import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import usePortalAuth from '../../../auth/usePortalAuth';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { postApiData } from '../../../utils/service';
import { useQuery } from 'react-query';

import basePCUrl from '../../../Globals';

const LanguageDropdown = (props) => {
  const { getAccessTokenSilently } = usePortalAuth();
  const { useTheme } = require('@material-ui/core/styles');

  const [chosenLanguageChange, setChosenLanguageChange] = useState(false);
  const isLoading = props.isLoading;
  const preferredLanguage = props.preferredLanguage;

  // useEffect(() => {
  //   const preferredLanguage = localStorage.getItem('preferred-language');
  //   const supportedLanguages = ['zh', 'ja', 'fr', 'de', 'it', 'es', 'nl', 'pt', 'en', 'no'];

  //   if (!preferredLanguage && supportedLanguages.includes(navigator.language.split('-')[0])) {
  //     localStorage.setItem(
  //       'preferred-language',
  //       navigator.language.split('-')[0] === 'en' ? 'EN' : navigator.language.split('-')[0]
  //     );
  //     //console.log('I am using the navigator language');
  //   } else {
  //     return;
  //   }
  // }, []);

  const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.23)',
      },
      '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.87)',
      },
      '& .MuiInputBase-root': {
        color: theme.palette.text.primary,
      },
      '& .MuiSelect-icon': {
        color: theme.palette.text.primary,
      },
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  }));

  const classes = useStyles();
  const muiTheme = useTheme();

  let userSettings = props.userSettings;
  let isNotLoading = props.isNotLoading;

  var setPreferredLanguageData;

  const savePreferredLanguage = useQuery(
    ['setUserSettings'],
    async () => {
      const token = await getAccessTokenSilently();

      return postApiData(
        basePCUrl,
        token,
        setPreferredLanguageData,
        'setUserSettings'
      );
    },
    {
      enabled: false,
      onSuccess: () => {
        setChosenLanguageChange(false);
        //console.log("I have made the save settings call.")
        //window.location.reload();
      },
    }
  );

  const handleChange = (event) => {
    props.setPreferredLanguage(event.target.value);

    setPreferredLanguageData = {
      chrome: userSettings?.Chrome?.Value,
      firefox: userSettings?.Firefox?.Value,
      outlook: userSettings?.Outlook?.Value,
      darkmode: userSettings?.DarkMode,
      userlanguage: event.target.value,
    };

    setTimeout(() => {
      savePreferredLanguage.refetch();
    }, 2000);

    setTimeout(() => {
      if (
        props.location.pathname === '/Dashboard/TrainingDashboard'
      ) {
        window.location.reload();
      }
    }, 3000);

    //window.dispatchEvent(new Event("storageLanguageChanged"));
  };

  return (
    //     <FormControl variant="outlined" className={classes.formControl}>
    //   <Select
    //     labelId="date range select"
    //     value={dateRange}
    //     onChange={(e) => setDateRange(e.target.value)}
    //     style={{ marginLeft: '0px', marginRight: '35px', width: '150px' }}
    //   >
    //     <MenuItem value="8">7 days</MenuItem>
    //     <MenuItem value="15">14 days</MenuItem>
    //     <MenuItem value="31">30 days</MenuItem>
    //   </Select>
    // </FormControl>
    <div>
      {userSettings ? (
        <FormControl variant="outlined" className={classes.formControl}>
          <Select
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            value={preferredLanguage}
            onChange={(event) => handleChange(event)}
            label="Language"
            style={{ color: muiTheme.palette.text.primary }}
            MenuProps={{ disableScrollLock: true }}
          >
            <MenuItem value={'EN'}>English</MenuItem>
            {/* <MenuItem value={'EN'}>English - GB</MenuItem> */}
            <MenuItem value={'AR'}>Arabic</MenuItem>
            <MenuItem value={'ZH'}>Chinese</MenuItem>
            <MenuItem value={'NL'}>Dutch</MenuItem>
            <MenuItem value={'FR'}>French</MenuItem>
            <MenuItem value={'DE'}>German</MenuItem>
            <MenuItem value={'EL'}>Greek</MenuItem>
            <MenuItem value={'HI'}>Hindi</MenuItem>
            <MenuItem value={'IT'}>Italian</MenuItem>
            <MenuItem value={'JA'}>Japanese</MenuItem>
            <MenuItem value={'KO'}>Korean</MenuItem>
            <MenuItem value={'NB'}>Norwegian</MenuItem>
            {/* <MenuItem value={'PT'}>Portuguese - BR</MenuItem> */}
            <MenuItem value={'PT'}>Portuguese</MenuItem>
            <MenuItem value={'ES'}>Spanish</MenuItem>
          </Select>
        </FormControl>
      ) : null}
    </div>
  );
};
export default LanguageDropdown;
